/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const additionalSubmissionQuestionDataQuestionTypeSchema = z.enum([
	'select',
	'text',
	'open_text',
	'file',
	'datetime',
])

export type AdditionalSubmissionQuestionDataQuestionTypeSchema = z.infer<
	typeof additionalSubmissionQuestionDataQuestionTypeSchema
>
